import { Pipe, PipeTransform } from '@angular/core';

@Pipe({standalone: true, name: "removeUnderscores"})
export class RemoveUnderscoresPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/_/g, ' ');
  }
}
